<template>
  <section
    class="app-reward border container"
    :class="{ loaded: loadedView.indexOf('reward') !== -1 }"
  >
    <h3 class="block__topic" id="reward">大赛奖品</h3>

    <div class="app-reward-desc">
      <div class="app-reward-desc__img"></div>

      <div class="app-reward-desc__content">
        <p>
          <span class="order-num">1</span>
          <span>本次大赛分别设立周排行奖项和总得分排行奖项。</span>
        </p>
        <p style="padding-left: 24px">
          <span class="order-num">2</span>【周奖】根据每周综合得分排名先后，轻量组和重量组的第一名，给予奖励1000元/1888元。共8个周，合计16名。
        </p>
        <p style="padding-left: 24px">
          <span class="order-num">3</span>
          <span style="line-height: 24px">【总奖励】以下分别为重量组和轻量组的总奖励：<br />
          <strong>一等奖：重量组60000元/轻量组30000元+交易MVP冠军杯+荣誉证书+冠军专访；</strong><br />
          <strong>二等奖：重量组30000元/轻量组18888元+荣誉证书+专访；</strong><br />
          <strong>三等奖：重量组10000元/轻量组8888元+荣誉证书；</strong><br />
          优秀奖：重量组1888元/轻量组1000元；</span>
        </p>
      </div>
    </div>

    <div class="app-reward-cups">
      <div class="app-reward-cups-item blod-item">
        <h3 class="app-reward-cups-item__title">重量级</h3>
      </div>
      <div class="app-reward-cups-item light-item">
        <h3 class="app-reward-cups-item__title">轻量级</h3>
      </div>
    </div>

    <p class="app-reward__tip">*（若综合得分相同，则以期初权益资金大者优胜，若期初权益资金亦相同，以交易量大者优胜；若交易量亦相同，则以最大本金收益率高者优胜。）</p>

    <div class="app-reward-details" :class="{ active: detailVisible }">
      <button
        class="app-reward-details__btn"
        @click="onDetailChange"
      >
        <span>奖品说明<i class="arrow"></i></span>
      </button>

      <div v-if="detailVisible" class="app-reward-details__content">
        <p>
          <span class="order-num">1</span>
          <span>大赛结束1个月内，将在本网站公布获奖名单，并根据报名时留存的个人资料进行电话通知。3个月逾期不领取奖品视为获奖者主动放弃。</span>
        </p>
        <p>
          <span class="order-num">2</span>
          <span>获奖参赛者需承担20%个人所得税，主办方负责协助参赛者申报个人所得税，代扣代缴。</span>
        </p>
      </div>

      <div class="app-reward-details__bottom"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Reward",
  props: {
    loadedView: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      detailVisible: false
    }
  },
  methods: {
    onDetailChange() {
      this.detailVisible = !this.detailVisible
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/vars.scss";
@import "../../styles/mixin.scss";

.app-reward {
  position: relative;
  margin: percentage(123px / $baseWidth) auto 0;
  border: 1px solid transparent;

  &-desc__content,
  &-details__content {
    p {
      margin: 10px 0;
      position: relative;
      vertical-align: middle;
      line-height: 22px;
      padding-left: 32px;
    }
    .order-num {
      position: absolute;
      left: 0;
      display: inline-block;
      margin-right: 10px;
      width: 22px;
      height: 22px;
      font-size: 12px;
      line-height: 22px;
      color: #a2655c;
    }
  }

  &-details {
    margin: percentage(40px / 1200px) auto 0;
    &__btn {
      margin: 0 auto;
      display: block;
      position: relative;
      width: percentage(160px / 1200px);
      padding-top: percentage(42px / 1200px);
      @include image-2x(
        "../../assets/reward-detail-btn@1x.png",
        center,
        no-repeat,
        100% auto
      );
      span {
        color: $primaryColor;
        font-size: 15px;
        white-space: nowrap;
        @include middle();
      }
      .arrow {
        display: inline-block;
        transform: translate(0, -2px);
        margin-left: 8px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 5px 5px 0 5px;
        border-color: #985E57 transparent transparent transparent;
      }
    }

    &__content {
      position: relative;
      margin: percentage(22px / 1200px) auto 0;
      padding: percentage(16px / 1200px) percentage(64px / 1200px);
      background: linear-gradient(
        270deg,
        rgba(90, 53, 46, 0) 0%,
        rgba(90, 53, 46, 0.39) 47%,
        rgba(90, 53, 46, 0) 100%
      );
      p {
        margin: 12px 0;
        font-size: 14px;
        line-height: 24px;
        color: $primaryColor;
      }
      &::after {
        content: "";
        position: absolute;
        top: -10px;
        left: 50%;
        margin-left: -5px;
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 10px solid rgba(90, 53, 46, 0.39);
      }
    }
    &__bottom {
      margin: percentage(21px / 1200px) auto 0;
      width: percentage(245px / 1200px);
      padding-top: percentage(28px / 1200px);
      @include image-2x(
        "../../assets/reward-detail-bottom@1x.png",
        center top,
        no-repeat,
        100% auto
      );
    }
    &.active {
      .app-reward-details__btn {
        span {
          color: #ebc4bc;
        }
        .arrow {
          border-width: 0 5px 5px 5px;
          border-color: transparent transparent #ebc4bc transparent;;
        }
      }
    }
  }

  &__tip {
    margin: percentage(30px / 1200px) auto 0;
    font-size: 14px;
    color: #db8777;
    text-align: center;
  }

  &-desc {
    display: flex;
    align-items: center;
    margin: percentage(62px / 1200px) auto 0;
    position: relative;
    overflow: hidden;

    &__img {
      margin-right: 10px;
      width: percentage(191px / 1200px);
      padding-top: percentage(191px / 1200px);
      image-rendering: -webkit-optimize-contrast;

      @include image-2x(
        "../../assets/reward-desc@1x.png",
        center top,
        no-repeat,
        100% auto
      );
    }

    &__content {
      flex: 1;
      // position: absolute;
      // right: 0;
      // top: 50%;
      // transform: translate(0, -50%);
      padding: percentage(10px / 1200px) 0;
      width: percentage(1008px / 1200px);
      font-size: 16px;
      color: #f1c9c0;
      background: linear-gradient(
        270deg,
        rgba(90, 53, 46, 0) 0%,
        rgba(90, 53, 46, 0.39) 47%,
        rgba(90, 53, 46, 0) 100%
      );

      span {
        display: inline-block;
      }
    }
  }

  &-cups {
    margin: percentage(74px / 1200px) auto 0;
    &-item {
      display: inline-block;
      position: relative;
      width: percentage(580px / 1200px);
      padding-top: percentage(450px / 1200px);
      image-rendering: -webkit-optimize-contrast;
      @include image-2x(
        "../../assets/b-reward-bg@1x.png",
        center top,
        no-repeat,
        contain
      );

      &.light-item {
        float: right;
        @include image-2x(
          "../../assets/l-reward-bg@1x.png",
          center top,
          no-repeat,
          contain
        );

        .app-reward-cups-item__title {
          @include image-2x(
            "../../assets/light-title@1x.png",
            center top,
            no-repeat,
            100% auto
          );
        }
      }

      &__title {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
        font-size: 0;
        text-indent: -999em;
        width: percentage(189px / 582px);
        padding-top: percentage(68px / 582px);
        margin-top: percentage(-49px / 582px);
        image-rendering: -webkit-optimize-contrast;
        @include image-2x(
          "../../assets/blod-title@1x.png",
          center top,
          no-repeat,
          100% auto
        );
      }
    }
  }

  .block__topic {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -65.0625%);
    @include image-2x(
      "../../assets/title-reward@1x.png",
      center top,
      no-repeat,
      100% auto
    );

    &:before,
    &:after {
      content: "";
      position: absolute;
      top: percentage(21px / 83px);
      width: percentage(139px / 137px);
      padding-top: percentage(6px / 137px);
    }

    &:before {
      left: -100%;
      margin-left: -18px;
      background: url(../../assets/title-line.png) center/contain no-repeat;
    }

    &:after {
      right: -100%;
      margin-right: -18px;
      background: url(../../assets/title-line.png) center/contain no-repeat;
      transform: rotate(180deg);
    }
  }
}

@include mobile {
  .app-reward {
    margin: percentage(76px / 414px) auto 0;
    
    &__tip {
      margin: percentage(20px / 406px) auto 0;
      padding: 0 percentage(22px / 406px) 0;
      font-size: 10px;
    }

    &-cups {
      margin: percentage(54px / 1200px) auto 0;
      overflow: hidden;

      &-item {
        width: 100%;
        display: block;
        margin: percentage(32px / 406px) auto 0;
        padding-top: percentage(300px / 388px);
      }
    }

    &-desc__content,
    &-details__content {
      p {
        padding-left: 25px;
        margin: 10px 0;
      }
    
      .order-num {
        margin-right: 7px;
      }
    }
    
    &-desc {
      display: block;
      padding: 0 percentage(8px / 406px);
      overflow: hidden;

      &__img {
        width: percentage(68px / 406px);
        padding-top: percentage(16px / 406px);
        margin: percentage(14px / 406px) auto 0;
        background: url(../../assets/m-reward-desc.png) center/contain no-repeat;
      }

      &__content {
        margin: percentage(10px / 406px) auto 0;
        width: 100%;
        position: relative;
        transform: none;
        font-size: 12px;

        p {
          line-height: 20px;
        }
      }
    }

    &-details {
      &__btn {
        margin: percentage(26px / 406px) auto 0;
        width: percentage(100px / 406px);
        padding-top: percentage(24px / 406px);

        span {
          font-size: 12px;
        }
      }

      &__content {
        p {
          font-size: 12px;
        }
        .order-num {
          margin-top: 3px;
        }
      }

      &__bottom {
        margin: percentage(20px / 406px) auto 0;
        width: percentage(163px / 406px);
        padding-top: percentage(18px / 406px);
      }
    }
  }
}

@include pad {
  .app {
    &-reward {
      &-desc__content, &-details__content {
        font-size: 14px;

        p, span {
          font-size: 14px;
          line-height: 26px;
        }

        .order-num {
          top: 4px;
        }
      }
    }
  }
}

@keyframes up {
  0% {
    opacity: .1;
    transform: translate3d(0,-6px,0)
  }

  50% {
    opacity: 1;
    transform: translate3d(0,0px,0)
  }

  to {
    opacity: .1;
    transform: translate3d(0,0px,0)
  }
}

</style>
